<template>
  <div class="m-field__label">
    {{ label }}<span class="required" v-if="required">&nbsp;*</span>
    <slot />
  </div>
</template>

<script>
export default {
  name: "OQLabel",
  props: ["label", "required"],
};
</script>

<style scoped></style>
